'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('isomorphic-fetch');

var _colonyJsContractLoader = require('@colony/colony-js-contract-loader');

var _HttpLoader2 = require('./HttpLoader');

var _HttpLoader3 = _interopRequireDefault(_HttpLoader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_HOST = 'http://127.0.0.1:3030';

var DEFAULT_ENDPOINT = DEFAULT_HOST + '/contracts?name=%%NAME%%&address=%%ADDRESS%%&version=%%VERSION%%'; // eslint-disable-line max-len

var TrufflepigLoader = function (_HttpLoader) {
  (0, _inherits3.default)(TrufflepigLoader, _HttpLoader);

  function TrufflepigLoader() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

    (0, _classCallCheck3.default)(this, TrufflepigLoader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TrufflepigLoader.__proto__ || Object.getPrototypeOf(TrufflepigLoader)).call(this, { transform: _colonyJsContractLoader.truffleTransform, endpoint: endpoint }));

    var _this$_endpoint$split = _this._endpoint.split('/contracts'),
        _this$_endpoint$split2 = (0, _slicedToArray3.default)(_this$_endpoint$split, 1),
        host = _this$_endpoint$split2[0];

    _this._host = host;
    return _this;
  }

  (0, _createClass3.default)(TrufflepigLoader, [{
    key: 'getAccounts',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(this._host + '/accounts');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.json());

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAccounts() {
        return _ref2.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: 'getAccount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(index) {
        var accounts, addresses, address, privateKey;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getAccounts();

              case 2:
                accounts = _context2.sent;
                addresses = Object.keys(accounts);

                if (addresses[index]) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('Account for index ' + index + ' not found');

              case 6:
                address = addresses[index];
                privateKey = accounts[address];
                return _context2.abrupt('return', { address: address, privateKey: privateKey });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAccount(_x2) {
        return _ref3.apply(this, arguments);
      }

      return getAccount;
    }()
  }]);
  return TrufflepigLoader;
}(_HttpLoader3.default);

exports.default = TrufflepigLoader;
//# sourceMappingURL=TrufflepigLoader.js.map